import React from 'react';
import SVGLoader from './SVGLoader';

type CarIconProps = {
  width?: number | string;
  height?: number | string;
  viewboxWidth?: number | string;
  viewboxHeight?: number | string;
  color?: string;
};

/**
 * Lucide "car" icon (ISC). Stroke-based; inherits currentColor.
 * @see https://lucide.dev/icons/car
 */
const CarIcon = ({
  width = 24,
  height = 24,
  viewboxWidth = 24,
  viewboxHeight = 24,
  ...rest
}: CarIconProps) => (
  <SVGLoader
    width={width}
    height={height}
    viewboxWidth={viewboxWidth}
    viewboxHeight={viewboxHeight}
    {...rest}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" />
      <circle cx="7" cy="17" r="2" />
      <path d="M9 17h6" />
      <circle cx="17" cy="17" r="2" />
    </g>
  </SVGLoader>
);

export default CarIcon;
